import isNil from 'lodash/isNil'
import { computeDefaultInsuredAmount } from './computeDefaultInsuredAmount'

/**
 * True once the shopper's declared value sits under the order-derived default. Before the seed
 * effect populates `insuredAmount` it is `undefined` -- that pre-seed case is checked explicitly
 * here rather than leaning on `undefined` comparing false against every number.
 */
export const isInsuredAmountBelowDefault = (insuredAmount?: number, gross?: number): boolean => {
  if (isNil(insuredAmount)) return false

  return insuredAmount < computeDefaultInsuredAmount(gross)
}
